"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatbotComponent = void 0;
const react_1 = __importStar(require("react"));
const ChatbotView_1 = require("./ChatbotView");
const easy_peasy_1 = require("easy-peasy");
require("./locales");
const store_1 = require("./store");
const theme_1 = require("./services/theme");
const CustomHeader_1 = require("./CustomHeader");
const ChatbotComponent = ({ chatbot, isPreview, disableAnimations, onChatbotAnswer, onChatbotCompleted, onCatchedError, }) => {
    var _a;
    const showLiteBadge = chatbot.settings
        ? chatbot.settings.showLiteBadge
        : true;
    const theme = (0, theme_1.parseTheme)(chatbot);
    (0, react_1.useEffect)(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            (0, theme_1.setTheme)(theme, document.documentElement.style, chatbot.settings.chatbotMaxWidth);
            if (typeof window !== "undefined") {
                const { default: WebFont } = yield Promise.resolve().then(() => __importStar(require("webfontloader")));
                WebFont.load({
                    google: {
                        families: [`${theme.fontFamily}:300,400,600`],
                    },
                });
            }
            listenToEngineCatchedErrors(onCatchedError);
        }))();
    }, []);
    return (react_1.default.createElement(easy_peasy_1.StoreProvider, { store: store_1.store },
        react_1.default.createElement("div", { className: "flex text-base overflow-hidden bg-cover h-full w-full typebot-container flex-col items-center", style: {
                backgroundColor: (0, theme_1.parseTheme)(chatbot).colors.siteBackground.value,
            } },
            ((_a = theme.customHeader) === null || _a === void 0 ? void 0 : _a.isEnabled) && (react_1.default.createElement(CustomHeader_1.CustomHeader, Object.assign({}, theme.customHeader.content))),
            react_1.default.createElement("div", { className: "flex w-full h-full justify-center" },
                react_1.default.createElement(ChatbotView_1.ChatbotView, { chatbot: chatbot, isPreview: isPreview, disableAnimations: disableAnimations, onChatbotAnswer: (answers) => __awaiter(void 0, void 0, void 0, function* () {
                        if (onChatbotAnswer)
                            yield onChatbotAnswer(answers);
                    }), onChatbotCompleted: () => __awaiter(void 0, void 0, void 0, function* () {
                        if (onChatbotCompleted)
                            yield onChatbotCompleted();
                    }) })),
            showLiteBadge && (react_1.default.createElement("a", { href: "https://www.typebot.io/?utm_source=litebadge" +
                    (chatbot.settings.referralUtm
                        ? `&via=${chatbot.settings.referralUtm}`
                        : ""), target: "_blank", rel: "noopener noreferrer", className: "fixed py-1 px-2 bg-white z-50 rounded shadow-md", style: { bottom: "20px" } },
                "Made with ",
                react_1.default.createElement("span", { className: "text-blue-500" }, "Typebot"),
                ".")))));
};
exports.ChatbotComponent = ChatbotComponent;
const listenToEngineCatchedErrors = (onCatchedError) => window.addEventListener("message", (event) => {
    const data = event.data;
    if (data.from === "typebot-engine" && data.error && onCatchedError)
        onCatchedError(data.error, data.extras);
});
__exportStar(require("./models"), exports);
__exportStar(require("./DefaultAvatar"), exports);
__exportStar(require("./services"), exports);
//# sourceMappingURL=index.js.map